// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5ffd84a9","703":"798de6ab","787":"dd26048a"}[chunkId] + ".chunk.js";
};